import { For, Portal, Show } from "solid-js/web";
import { $confirm_dialogs } from "./store";
import { Match, Switch, splitProps } from "solid-js";
import { directives$ } from ":ui/directives";
import IconSuccess from "./assets/success.svg";
import IconErrorOrange from "./assets/warn.svg";
import IconError from "./assets/error.svg";
import IconInfo from "./assets/info.svg";
import IconLoader from "./assets/loader.svg";
import { solidstate } from ":setup/qstate";

export default function ConfirmDialog() {
  // @ts-ignore: unused function 'clickOutside'
  const { clickOutside } = directives$.events;
  function removeDialog(index: number) {
    $confirm_dialogs.set((s) => {
      s.splice(index, 1);
      return [...s];
    });
  }
  function cancelDialog(props: { index: number; onCancel: () => void }) {
    removeDialog(props.index);

    props.onCancel?.();
  }
  return (
    <Portal>
      <Show when={$confirm_dialogs.value.length > 0}>
        <main class="!absolute bottom-0 !z-99 flex flex-col !items-center !justify-center w-full h-full bg-bg-shade">
          <For each={$confirm_dialogs.value}>
            {(props, index) => {
              const [local, other] = splitProps(props, [
                "type",
                "message",
                "note",
                "events",
                "cancel_msg",
                "confirm_msg",
              ]);

              const $loading = solidstate.create(false);
              return (
                //? outer container
                <section
                  // use:clickOutside={() => {
                  //   removeDialog(index());
                  //   local.events?.onCancelled?.();
                  // }}
                  class="flex flex-col min-w-440px max-w-440px min-h-204px text-16px self-center !items-center !justify-center !z-10 <sm:(min-w-95%)"
                >
                  {/* inner container */}
                  <section class="relative flex flex-col w-full h-full justify-between !self-center !z-50  overflow-hidden rounded-20px bg-bg text-text py-2">
                    <div
                      class="i-ic:baseline-close w-24px h-24px absolute left-4% top-10% text-text-alt cursor-pointer"
                      onclick={() => cancelDialog({ index: index(), onCancel: local.events?.onCancelled })}
                    />
                    {/* icons and message */}
                    <div class="flex flex-col items-center justify-center gap-1 px-2 pb-2 ">
                      {/* icons */}
                      <div class="children:(min-w-90px min-h-90px rounded-lg px-2)">
                        <Switch>
                          <Match when={local.type === "warn"}>
                            <IconErrorOrange />
                          </Match>
                          <Match when={local.type === "error"}>
                            <IconError />
                          </Match>
                          <Match when={local.type === "success"}>
                            <IconSuccess />
                          </Match>
                          <Match when={true}>
                            <IconInfo />
                          </Match>
                        </Switch>
                      </div>
                      {/* message */}
                      <p class="flex flex-col w-full font-bold text-16px text-center gap-1">
                        {local.message ?? "MESSAGE MISSING"}
                        {local.note != undefined && (
                          <span class="text-text-alt font-normal capitalize text-center text-14px w-full">
                            {local.note}
                          </span>
                        )}
                      </p>
                    </div>
                    <div
                      class={
                        "flex flex-row w-full capitalize items-center justify-center gap-2 px-2 pt-2 border-bg-alt border-solid border-t-2" +
                        " " +
                        "children:(flex flex-row items-center justify-center)" +
                        " " +
                        "children:(!w-full capitalize rounded-lg font-semibold text-0.55rem px-4 py-10px rounded-md cursor-pointer <sm:(text-13px))" +
                        " " +
                        "children:(<sm:(text-13px))"
                      }
                    >
                      <button
                        class="text-text"
                        onClick={() => cancelDialog({ index: index(), onCancel: local.events?.onCancelled })}
                      >
                        {local.cancel_msg ?? "Cancel"}
                      </button>
                      <button
                        class={`
                        ${local.type === "info" ? "bg-info-shade text-info " : ""}
                        ${local.type === "warn" ? "bg-warn-shade text-warn" : ""}
                        ${local.type === "error" ? "bg-error-shade text-error" : ""}
                        ${local.type === "success" ? "bg-success-shade text-success" : ""}
                        `}
                        onClick={async () => {
                          $loading.set(true);
                          try {
                            await local.events?.onConfirmed?.();
                            removeDialog(index());
                          } catch (e) {}
                          $loading.set(false);
                        }}
                      >
                        <Show when={$loading.value} fallback={local.confirm_msg ?? "Confirm"}>
                          <IconLoader class="h-24px animate animate-spin" />
                        </Show>
                      </button>
                    </div>
                  </section>
                </section>
              );
            }}
          </For>
        </main>
      </Show>
    </Portal>
  );
}
